"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";

function ArchiveHeaderContent() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading) {
    return (
      <div className="flex flex-col items-center space-y-4 text-center md:items-start md:text-left">
        <div className="h-5 w-48 animate-pulse rounded-md bg-muted"></div>
        <div className="h-10 w-64 animate-pulse rounded-md bg-muted"></div>
      </div>
    );
  }

  if (error || links.length === 0) {
    return (
      <div className="flex flex-col items-center space-y-4 text-center md:items-start md:text-left">
        <h1 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
          Shop
        </h1>
      </div>
    );
  }

  const lastIndex = links.length - 1;
  const currentTitle = links[lastIndex]?.title || "Shop";

  return (
    <div className="flex flex-col items-center space-y-4 text-center md:items-start md:text-left">
      <Breadcrumb>
        <BreadcrumbList className="justify-center md:justify-start">
          {links.map((link, i) => {
            const isLast = i === lastIndex;
            return (
              <React.Fragment key={link.href}>
                <BreadcrumbItem data-index={i}>
                  {isLast ? (
                    <BreadcrumbPage className="font-medium text-foreground">
                      {link.title}
                    </BreadcrumbPage>
                  ) : (
                    <BreadcrumbLink asChild>
                      <Link to={link.href}>{link.title}</Link>
                    </BreadcrumbLink>
                  )}
                </BreadcrumbItem>
                {!isLast && <BreadcrumbSeparator />}
              </React.Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>

      <h1 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
        {currentTitle}
      </h1>
    </div>
  );
}

export default function ArchiveTitle() {
  return (
    <section id="archive-title" className="bg-background py-8 md:py-12 lg:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <ShopBreadcrumbsProvider>
          <ArchiveHeaderContent />
        </ShopBreadcrumbsProvider>
      </div>
    </section>
  );
}